import { useEffect, useRef, useCallback } from 'react';

export const useSilentSaveListener = (tabKey, silentSaveFn) => {
  const saveFnRef = useRef(silentSaveFn);
  useEffect(() => {
    saveFnRef.current = silentSaveFn;
  });

  const stableHandler = useCallback((event) => {
    const { tabKey: targetTab, resolve } = event.detail;
    if (targetTab === tabKey) {
      Promise.resolve(saveFnRef.current())
        .then(resolve)
        .catch(() => resolve('skipped'));
    }
  }, [tabKey]);

  useEffect(() => {
    window.addEventListener('ebiosrm_silent_save_request', stableHandler);
    return () => window.removeEventListener('ebiosrm_silent_save_request', stableHandler);
  }, [stableHandler]);
};

export default useSilentSaveListener;